import { createInvitationDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createInvitationCallable = getCallable(createInvitationDefinition);
